// Storage keys
export const STORAGE_KEYS = {
  TOKENS: 'coldsea_deploy_tokens',
  USER: 'coldsea_deploy_user',
  ORGS_LIST: 'coldsea_deploy_orgs_list',
  ORGS_LIST_TIMESTAMP: 'coldsea_deploy_orgs_list_timestamp',
  REMEMBER_ME: 'rememberMe',
  LAST_LOGIN_EMAIL: 'lastLoginEmail',
  SCRIPT_EDITOR_WORD_WRAP: 'coldsea_deploy_script_editor_word_wrap',
  TASK_TEMPLATE_EDITOR_PANEL_WIDTH: 'coldsea_deploy_task_template_editor_panel_width',
  TASK_TEMPLATE_EDITOR_PANEL_COLLAPSED: 'coldsea_deploy_task_template_editor_panel_collapsed',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    PROFILE: '/api/v1/auth/me',
    REFRESH: '/api/v1/auth/refresh',
    REQUEST_PASSWORD_RESET: '/api/v1/auth/request-password-reset',
    RESET_PASSWORD: '/api/v1/auth/reset-password',
    RESET_PASSWORD_WITH_JWT: '/api/v1/auth/reset-password-with-jwt',
    USER_ORGANIZATIONS: '/api/v1/auth/user-organizations',
    // Secure cookie-based auth endpoints
    SECURE_LOGIN: '/api/v1/auth/secure/login',
    SECURE_REFRESH: '/api/v1/auth/secure/refresh',
    SECURE_LOGOUT: '/api/v1/auth/secure/logout',
    CSRF_TOKEN: '/api/v1/auth/secure/csrf-token',
  },
  ORGANIZATIONS: '/api/v1/organizations/',
  USERS: '/api/v1/users/',
  WORKFLOWS: '/api/v1/workflows/',
  HOSTS: '/api/v1/hosts/',
  API_KEYS: '/api/v1/api-keys/',
  COMPONENTS: '/api/v1/components/',
  // Component templates (formerly action templates)
  ACTION_TEMPLATES: '/api/v1/components/templates/',
  COMPONENT_TEMPLATES: '/api/v1/components/templates/', // New alias for clarity
  PERMISSIONS: '/api/v1/permissions/',
  ROLES: '/api/v1/roles/',
  SUBSCRIPTIONS: {
    CURRENT: '/api/v1/subscriptions/current',
    USAGE: '/api/v1/subscriptions/usage',
    TIERS: '/api/v1/subscriptions/tiers',
    CREATE_CHECKOUT_SESSION: '/api/v1/subscriptions/create-checkout-session',
    CREATE_PORTAL_SESSION: '/api/v1/subscriptions/create-portal-session',
    CANCEL: '/api/v1/subscriptions/cancel',
    CHANGE_PLAN: '/api/v1/subscriptions/change-plan',
    SYNC_CUSTOMER_INFO: '/api/v1/subscriptions/sync-customer-info',
    SYNC_SUBSCRIPTION: '/api/v1/subscriptions/sync-subscription',
    RECONCILE: '/api/v1/subscriptions/reconcile',
  },
  STORAGE: {
    FILES: '/api/v1/storage/files/',
    UPLOAD: '/api/v1/storage/files/upload',
    FOLDERS: '/api/v1/storage/folders/',
    QUOTA: '/api/v1/storage/quota',
  },
  ADMIN: {
    SUBSCRIPTIONS: {
      SYNC_PRODUCTS: '/api/v1/admin/subscriptions/sync-stripe-products',
      ENROLL_ORGANIZATIONS: '/api/v1/admin/subscriptions/enroll-existing-organizations',
    },
    SYSTEM_LISTS: '/api/v1/admin/system-lists/',
    LOGS: {
      AUDIT: '/api/v1/admin/logs/audit',
      APPLICATION: '/api/v1/admin/logs/application',
      SYSTEM: '/api/v1/admin/logs/system',
      AUDIT_EXPORT: '/api/v1/admin/logs/audit/export',
    },
    STATS: {
      EXPORT: '/api/v1/admin/stats/export',
    },
  },
  SYSTEM_LISTS: '/api/v1/system-lists/',
  WEBHOOKS: {
    BASE: '/api/v1/webhooks/org/',
    EVENTS: '/api/v1/webhooks/org/events',
  },
  NOTIFICATIONS: {
    INBOX: '/api/v1/notifications/',
    UNREAD_COUNT: '/api/v1/notifications/unread-count',
    LOGIN_ANNOUNCEMENTS: '/api/v1/notifications/login-announcements',
    MARK_ALL_READ: '/api/v1/notifications/mark-all-read',
  },
} as const;

// Auth configuration
export const AUTH_CONFIG = {
  TOKEN_EXPIRY_BUFFER: 60, // seconds before expiry to refresh
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // milliseconds
} as const;

// Time-to-live for organization cache (milliseconds)
export const ORG_CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

// API Base URL - uses environment variable or defaults to empty string (same origin)
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) || '';
